// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.rheology-report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 7pt;
}
.rheology-report-table thead {
  display: table-header-group;
}
.rheology-report-table tr {
  break-inside: avoid;
  page-break-inside: avoid;
}
.rheology-report-table th,
.rheology-report-table td {
  padding: 3px 2px;
  border: 1px solid #aebac3;
  text-align: center;
  vertical-align: top;
  white-space: nowrap;
}
.rheology-report-table thead th {
  background: #fff;
  color: #20252b;
  font-size: 6.5pt;
  font-weight: 700;
}
.rheology-report-table .rheology-title-row th {
  background: #ffffe5;
  color: #20252b;
  font-size: 9pt;
  font-weight: 400;
  padding: 2px;
}
.rheology-report-table tbody td {
  background: #ffffe5;
  border-color: #20252b;
}

.empty-state {
  margin: 4px 0;
  color: #69747d;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-report/job-request-report-tests/rheology-test-report.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;AACE;EAAQ,2BAAA;AAEV;AAAE;EACE,mBAAA;EACA,wBAAA;AAEJ;AACE;;EAEE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAEE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AADJ;AAIE;EACE,mBAAA;EACA,qBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AAHF","sourcesContent":[":host {\n  display: block;\n}\n\n.rheology-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 7pt;\n\n  thead { display: table-header-group; }\n\n  tr {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  th,\n  td {\n    padding: 3px 2px;\n    border: 1px solid #aebac3;\n    text-align: center;\n    vertical-align: top;\n    white-space: nowrap;\n  }\n\n  thead th {\n    background: #fff;\n    color: #20252b;\n    font-size: 6.5pt;\n    font-weight: 700;\n  }\n\n  .rheology-title-row th {\n    background: #ffffe5;\n    color: #20252b;\n    font-size: 9pt;\n    font-weight: 400;\n    padding: 2px;\n  }\n\n  tbody td {\n    background: #ffffe5;\n    border-color: #20252b;\n  }\n}\n\n.empty-state {\n  margin: 4px 0;\n  color: #69747d;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
